import React, { useState } from "react";
import { useNavigate } from "react-router";
import {
  Card,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

const ShowCard = ({ isOpen, toggle }) => {

  const handleDone = () => {
    toggle(); // Close the modal
    window.location.reload(); // Reload the page
  };


  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: "25px" }} centered>
      <h4
        onClick={toggle}
        className="text-end pt-2 cursor-pointer"
        style={{ paddingRight: "5px" }}
      >
        <i className="bx bx-x"></i>
      </h4>

      <div className="text-center ">
        <div className="avatar-md mb-4 mx-auto">
          <div className="avatar-title bg-light text-success display-4 rounded-circle">
            <i className="ri-checkbox-circle-fill"></i>
          </div>
        </div>
        <h5>Thank you for submitting your information</h5>
        <p className="text-muted">
          We will analyze your information and get back to you ASAP
        </p>
        <div className="d-flex align-items-start gap-3 mt-4 mb-4">
          <button
            type="button"
            className="btn btn-success mx-auto nexttab w-50"
            onClick={handleDone}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ShowCard;
